import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/common";
import { ShieldCheck } from "lucide-react";
import Seo from "@/components/Seo";
import PromoBanner from "@/components/PromoBanner";

const RULES = [
    "Treat others with respect and warmth.",
    "Follow the rules of every venue we visit.",
    "No harassment of any kind.",
    "No threats, intimidation, or violence.",
    "No stalking or unwanted repeated contact.",
    "No discriminatory harassment.",
    "No unwanted sexual behavior.",
    "No illegal conduct.",
    "No solicitation or spam.",
    "Respect other people's boundaries — a 'no' is complete.",
    "Report concerning behavior through the app.",
];

export default function CommunityStandards() {
    return (
        <div className="min-h-screen bg-background">
            <Seo title="Community Standards" description="The values and standards that keep Single Social Club a respectful, privacy-conscious, verification-forward community for adult singles." path="/community-standards" />
            <PromoBanner />
            <header className="border-b border-black/5">
                <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4">
                    <Logo />
                    <Link to="/" className="text-sm text-accent hover:underline">Home</Link>
                </div>
            </header>
            <main className="mx-auto max-w-3xl px-5 py-12">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-primary">
                    <ShieldCheck className="h-6 w-6" />
                </div>
                <h1 className="mt-5 font-display text-4xl font-700 tracking-tight text-primary">Community Standards</h1>
                <p className="mt-3 text-muted-foreground">
                    Single Social Club is a community built on trust and good faith. Participation is voluntary,
                    and these standards keep our outings welcoming and safe for everyone.
                </p>
                <ul className="mt-8 space-y-3">
                    {RULES.map((r, i) => (
                        <li key={i} className="flex items-start gap-3 rounded-xl bg-card p-4 shadow-sm">
                            <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-primary text-xs font-700 text-primary-foreground">{i + 1}</span>
                            <span className="text-sm text-foreground">{r}</span>
                        </li>
                    ))}
                </ul>
                <div className="mt-8 rounded-xl border border-amber-300/60 bg-amber-50 p-4 text-sm text-amber-800">
                    <strong>Placeholder legal copy — for attorney review before production launch.</strong> Single Social Club
                    verifies membership details but does not guarantee any person's safety or background. We do not automatically
                    share your phone number, email, home address, or social media. During your first meeting, we recommend using
                    the in-app group chat rather than exchanging personal contact information.
                </div>
            </main>
        </div>
    );
}
